import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ALL_CONSTANT, EntityTypes, Status } from '@guryou/core';

const BreadCrumb = ({ onChangeService, onChangeStatus }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const [activeTab2, setActiveTab2] = useState(5);

  const breadCrumbLinks = [
    { text: t('GENERAL.all'), value: ALL_CONSTANT },
    { text: t('GENERAL.services'), value: EntityTypes.service },
    { text: t('GENERAL.courses'), value: EntityTypes.course },
    { text: t('GENERAL.events'), value: EntityTypes.event },
    { text: t('GENERAL.videos'), value: EntityTypes.video },
    { text: t('PROFILE.upcoming'), value: Status.upcoming },
    { text: t('PROFILE.completed'), value: Status.completed },
  ];

  const handleChange = (type, idx) => {
    if (idx <= 4) {
      setActiveTab(idx);
      onChangeService && onChangeService(type);
    } else {
      setActiveTab2(idx);
      onChangeStatus && onChangeStatus(type);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-4">
      <div className="flex flex-wrap items-center gap-2">
        {breadCrumbLinks.map(
          (x, idx) =>
            idx <= 4 && (
              <button
                key={idx}
                type="button"
                onClick={() => handleChange(x.value, idx)}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                  activeTab === idx ? `bg-[var(--feel-primary)] text-white` : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {x.text}
              </button>
            )
        )}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {breadCrumbLinks.map(
          (x, idx) =>
            idx > 4 && (
              <button
                key={idx}
                type="button"
                onClick={() => handleChange(x.value, idx)}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                  activeTab2 === idx ? `bg-[var(--feel-primary)] text-white` : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {x.text}
              </button>
            )
        )}
      </div>
    </div>
  );
};

export default BreadCrumb;
